import React from 'react';

import InputWrapper from '../../common/InputWrapper';
import Quill from '../../common/Quill';
import { useAutoTranslation } from '../../../helpers/useAutoTranslation';

const TopBlock = (props) => {
  const { values, errors, setFieldValue, handleChangeInput, type } = props;

  const { t } = useAutoTranslation();

  const typesNames = {
    BUNDLE: 'набора',
    PHYSICAL_SET: 'комплекта',
    SKU: 'товара',
    SUBSCRIPTION: 'подписки',
    SERVICE: 'услуги',
    PACKING_MATERIAL_BOXES: 'упаковочного короба',
    PACKING_MATERIAL_OTHER: 'расходного материала',
    PACKING_MATERIAL_ATTACHMENT: 'доп. вложения',
  };

  return (
    <div className="col-lg-6">
      <div className="card-box">
        <div className="row">
          <div className="col-12">
            <h4 className="header-title">{t(`Название ${typesNames[type]}`)}</h4>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <InputWrapper
                type="text"
                label={t('Название')}
                id="shortName"
                value={values.shortName}
                error={errors.shortName}
                onChange={(e) => handleChangeInput('shortName', e.target.value)}
                placeholder={t('Введите название')}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="form-group">
              <Quill
                label={t('Описание')}
                id="description"
                value={t(values.description)}
                error={errors.description}
                onChange={(value) => handleChangeInput('description', value)}
                placeholder={t('Введите описание')}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBlock;
